/**
 * Footer折叠功能处理脚本
 * 为手机端footer的link_list块提供折叠/展开功能
 */
class FooterCollapsible {
  constructor() {
    this.init();
  }

  /**
   * 初始化折叠功能
   */
  init() {
    // 只在手机端启用折叠功能
    if (window.innerWidth >= 750) {
      this.enableDesktopMode();
      return;
    }

    this.setupCollapsibleElements();
    this.bindEvents();
  }

  /**
   * 设置可折叠元素的初始状态
   */
  setupCollapsibleElements() {
    const triggers = document.querySelectorAll('[data-collapsible-trigger]');
    
    triggers.forEach(trigger => {
      // 设置ARIA属性
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      
      // 获取对应的内容元素
      const content = trigger.parentElement.querySelector('[data-collapsible-content]');
      if (content) {
        content.setAttribute('aria-hidden', 'true');
        // 默认折叠状态
        content.classList.remove('is-open');
      }
    });
  }

  /**
   * 绑定事件监听器
   */
  bindEvents() {
    // 点击事件
    document.addEventListener('click', this.handleClick.bind(this));
    
    // 键盘事件（支持Enter和Space键）
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    
    // 窗口大小变化事件
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  /**
   * 处理点击事件
   */
  handleClick(event) {
    const trigger = event.target.closest('[data-collapsible-trigger]');
    if (!trigger) return;
    
    event.preventDefault();
    this.toggleCollapsible(trigger);
  }

  /**
   * 处理键盘事件
   */
  handleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    
    const trigger = event.target.closest('[data-collapsible-trigger]');
    if (!trigger) return;
    
    event.preventDefault();
    this.toggleCollapsible(trigger);
  }

  /**
   * 处理窗口大小变化
   */
  handleResize() {
    // 防抖处理
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 750) {
        this.enableDesktopMode();
      } else {
        this.init();
      }
    }, 250);
  }

  /**
   * 切换折叠状态
   */
  toggleCollapsible(trigger) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const content = trigger.parentElement.querySelector('[data-collapsible-content]');
    
    if (!content) return;
    
    // 更新ARIA属性
    trigger.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    
    // 切换CSS类
    if (isExpanded) {
      content.classList.remove('is-open');
    } else {
      content.classList.add('is-open');
    }
    
    // 触发自定义事件
    const customEvent = new CustomEvent('footer:collapsible:toggle', {
      detail: {
        trigger,
        content,
        isExpanded: !isExpanded
      }
    });
    document.dispatchEvent(customEvent);
  }

  /**
   * 启用桌面模式（禁用折叠功能）
   */
  enableDesktopMode() {
    const triggers = document.querySelectorAll('[data-collapsible-trigger]');
    const contents = document.querySelectorAll('[data-collapsible-content]');
    
    triggers.forEach(trigger => {
      trigger.removeAttribute('aria-expanded');
      trigger.removeAttribute('role');
      trigger.removeAttribute('tabindex');
    });
    
    contents.forEach(content => {
      content.removeAttribute('aria-hidden');
      content.classList.add('is-open');
    });
  }
}

// 当DOM加载完成后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FooterCollapsible();
  });
} else {
  new FooterCollapsible();
}

// 导出类以供其他脚本使用
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FooterCollapsible;
}